module.exports = __webpack_public_path__ + "img/66_2.3404581a.png";